import React, { createContext, useContext, useState, ReactNode } from 'react';

interface LearnContextType {
    isLearnOpen: boolean;
    setIsLearnOpen: (open: boolean) => void;
    currentLessonId: string | null;
    setCurrentLessonId: (id: string | null) => void;
    openLesson: (id: string) => void;
}

const LearnContext = createContext<LearnContextType | undefined>(undefined);

export const LearnProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [isLearnOpen, setIsLearnOpen] = useState(false);
    const [currentLessonId, setCurrentLessonId] = useState<string | null>(null);

    const openLesson = (id: string) => {
        setCurrentLessonId(id);
        setIsLearnOpen(true);
    };

    return (
        <LearnContext.Provider value={{
            isLearnOpen,
            setIsLearnOpen,
            currentLessonId,
            setCurrentLessonId,
            openLesson
        }}>
            {children}
        </LearnContext.Provider>
    );
};

export const useLearn = () => {
    const context = useContext(LearnContext);
    if (!context) {
        throw new Error('useLearn must be used within a LearnProvider');
    }
    return context;
};
